import type { OptimizationModel } from '@/shared/generated'

import { filter, pipe, size, values } from 'lodash/fp'

import { OptimizationStatus } from '@/shared/generated'

export const getUpdatingOptimizationsCount: (
	optimizations: OptimizationModel[]
) => number = pipe([
	values,
	filter(Boolean),
	filter({ status: OptimizationStatus.Updating }),
	size,
])
